import React, { useState, useEffect } from "react";
import { useSnackbarContext } from "../../contexts/Snackbar";
import { useHistory } from "react-router-dom";
import { pathname } from "../../utils";
import messages from "../../messages";
import ConnectBankAccount from "../../components/Bank/ConnectBank";

export default function BankOAuth() {
  const history = useHistory();
  const snackbar = useSnackbarContext();
  const [plaidLinkToken, setPlaidLinkToken] = useState(null);

  async function getPlaidLinkTokenWrapper() {
    try {
      const localToken = localStorage.getItem("plaidToken");
      if (!localToken) throw Error("Can't access token.");
      setPlaidLinkToken(localToken);
    } catch (error) {
      snackbar.show(messages.bank.errors.oAuth, "error");
    }
  }

  useEffect(() => {
    getPlaidLinkTokenWrapper();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <ConnectBankAccount
        plaidLinkToken={plaidLinkToken}
        onSuccess={() => history.push(pathname.account.main.url)}
        oAuthFlow={true}
      />
    </React.Fragment>
  );
}
